// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Cg","subtitle":"Dg","contentWrap":"Eg","imgWrap":"Fg","heading":"Gg","copy":"Hg"};